<template>
  <img v-if="formUrl()" width="1" height="1" :src="formUrl()" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NotifyCompleteSwitch',
  computed: {
    ...mapState({
      appSettings: ({ app_settings }) => app_settings,
      storage: ({ storage }) => storage,
      switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan
    })
  },
  methods: {
    formUrl() {
      const { switchOwnerReference } = this.appSettings;
      const { switchId, switchType } = this.storage.quote;
      const annualTariffCost = this.switchPlan.gasCost ? this.switchPlan.gasCost + this.switchPlan.cost : this.switchPlan.cost;
      const eMap = {
        gasToGas: 1105,
        electricityToElectricity: 1105,
        dualDistinctToDualConsolidated: 1106,
        dualConsolidatedToDualConsolidated: 1106
      };

      if (eMap[switchType] && switchOwnerReference && switchId && annualTariffCost) {
        return `https://mywebconect.com/p.ashx?o=1895&e=${eMap[switchType]}&f=pb&r=${switchOwnerReference}&t=${switchId}&p=PRICE&ect=${(annualTariffCost || 0)}`;
      }

      return null;
    }
  }
};
</script>

<style lang="scss"></style>
